import { render, staticRenderFns } from "./BodyAbout.vue?vue&type=template&id=706d2752&scoped=true"
import script from "./BodyAbout.vue?vue&type=script&lang=js"
export * from "./BodyAbout.vue?vue&type=script&lang=js"
import style0 from "./BodyAbout.vue?vue&type=style&index=0&id=706d2752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706d2752",
  null
  
)

export default component.exports